import { API_BASE } from '../config/api';

async function safeJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : null;
  } catch {
    return null;
  }
}

export async function fetchSettings() {
  const res = await fetch(`${API_BASE}/settings`);
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Failed to load settings');
  return await safeJson(res);
}

export async function saveSettings(formData) {
  const res = await fetch(`${API_BASE}/settings`, { method: 'POST', body: formData });
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Failed to save settings');
  return await safeJson(res);
}

